import { IoChevronBack } from "react-icons/io5";
/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Post } from '../compornents/Post';
import { Map, Marker } from '@vis.gl/react-google-maps';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons'
import { Analytics, Gtag } from '../compornents/Analytics';

export const Location2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const customer = location.state.customer;
  const position = { lat: 0, lng: 0 };
  const [isCenter, setCenter] = useState(position);

  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  const options = {
    disableDefaultUI: true,
    // デフォルトUI（衛星写真オプションなど）をキャンセルします。
    zoomControl: false,
    clickableIcons: false
  };
  // 顧客更新
  async function updateLocation() {
    openLoadingModal();
    // console.log('update');
    // 見積もり取得
    const request_data = {
      lat: isCenter.lat,
      lon: isCenter.lng,
    };
    const response_data = await Post('post', '/customer/update_location.php', request_data);
    // console.log(response_data);
    if (response_data.result === 1) {
      Gtag('update_location2_success');
      navigate("/account");
    } else {
      // エラー
      toast.error(response_data.error_message);
      Gtag('update_location2_failed', {
        error_message: response_data.error_message
      });
    }
    closeLoadingModal();
  };

  const geocode = () => {
    if (window.google && window.google.maps && typeof window.google.maps.Geocoder === 'function') {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: customer.pref + customer.add1 + customer.add2 + customer.add3 }, (results, status) => {
        if (status === 'OK') {
          setCenter({ lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() });
        } else {
          handleGeolocationFallback();
        }
      });
    } else {
      console.error("Google Maps API is not loaded or Geocoder is not a function.");
    }
  };

  const handleGeolocationFallback = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCenter({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      }, (error) => {
        console.error("Geolocation error:", error);
      });
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    geocode();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 戻る
  const back = () => {
    navigate(-1);
  };
  return (
    <>
      <div className="App">
        <Analytics title="ピンの位置を調整" />
        <div className="Location">
          <div className="toolbar">
            <div className="toolbar_left div_btn" onClick={back} >
              <IoChevronBack />
            </div>
            <div className="toolbar_center">
              ピンの位置を調整<span className="text-danger">(重要)</span>
            </div>
            <div className="toolbar_right">
            </div>
          </div>
          <div className="">
            <div className="mb-4 Register">

              <div className="App-map">
                <Map
                  center={isCenter}
                  zoom={18}
                  onCenterChanged={e => {
                    // console.log(e.detail.center.lat);
                    // console.log(e.detail.center.lng);
                    setCenter({ lat: e.detail.center.lat, lng: e.detail.center.lng });
                  }}
                  options={options}
                >
                  <Marker position={isCenter} />
                </Map>
              </div>
              <div className="Map-comment mb-3">
                Uber配達員が速やかにお伺いできるよう、ピンでお届け先の正しい位置を示してください
              </div>

              <div className="m-3">
                <button className="btn btn-oval btn-yellow form-control" onClick={() => updateLocation()}>変更を保存</button>
              </div>
            </div>
          </div>
          <LoadingModal>
            <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
              <button onClick={closeLoadingModal} className="hide">閉じる</button>
              <div >
                <TailSpin stroke="#000" />
              </div>
              <div className="">
                <div className="">
                  処理中です
                </div>
              </div>
            </div>
          </LoadingModal>
          <Tabbar menu="account" />
        </div>
      </div>
    </>
  );

}
